export default __webpack_public_path__ + "static/media/cash-blue.9683eb83.svg";